import { DropdownMenuItem } from '@/components/UI/Dropdown';
import { useSupportMode } from '@/contexts/SupportModeContext';
import useBaseCompanyInfo from '@/util/hooks/queries/useBaseCompanyInfo';
import useUserProfile from '@/util/hooks/queries/useUserProfile';
import { Undo2 } from 'lucide-react';
import type { FC } from 'react';

import { useSwitchCompany } from '../hooks/useSwitchCompany';

/**
 * Support-mode menu action: switch JWT context back to the user's default-company row
 * (UserProfile.companyId), using the same flow as Virtual Marketplace company switch.
 */
export const ReturnToMyCompanyMenuItem: FC = () => {
  const { isSupportMode } = useSupportMode();
  const { data: currentCompany } = useBaseCompanyInfo();
  const { data: user } = useUserProfile();
  const { mutate: switchToMyCompany, isPending: isSwitchingToHomeCompany } =
    useSwitchCompany();

  const homeCompanyId =
    user?.companyId != null && !Number.isNaN(Number(user.companyId))
      ? Number(user.companyId)
      : 0;
  const visible =
    isSupportMode &&
    homeCompanyId > 0 &&
    currentCompany?.companyId != null &&
    currentCompany.companyId !== homeCompanyId;

  if (!visible) {
    return null;
  }

  return (
    <DropdownMenuItem
      disabled={isSwitchingToHomeCompany}
      onClick={() => switchToMyCompany({ companyId: homeCompanyId })}
      className="gap-2.5 px-4 py-2 text-[13px] font-normal text-gray-700"
    >
      <Undo2 className="h-4 w-4 text-gray-400" />
      Return to my company
    </DropdownMenuItem>
  );
};
